import { ColumnElement } from '@atoms/columnElement';
import { VariableSelector } from '@atoms/dataSelectors/variableSelector/variableSelector';
import { InfoTooltip } from '@atoms/infoTooltip';
import { SwitchV2 } from '@atoms/switch';
import { Column } from '@components/dnd/base/blockBase/body.block.style';
import { TableSettings } from '@components/trace/table/table.settings';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle
} from '@components/ui/card';
import { Label } from '@components/ui/label';
import { Separator } from '@components/ui/separator';
import useAction from '@hooks/useAction';
import { TableEditorActionModel } from '@models/action/tableEditor.model';
import { SettingsSharedTab } from '@panel/components/action/shared/tabs';
import type { ResolvedVariableType } from '@stratumn/studio-shared';
import { observer } from 'mobx-react';

export const TableEditorSettingsTab = observer(() => {
  const action = useAction();
  if (!(action instanceof TableEditorActionModel)) {
    return <></>;
  }

  return (
    <SettingsSharedTab>
      <Card>
        <CardHeader>
          <CardTitle>Editor options</CardTitle>
          <CardDescription>
            Those settings while apply to all columns, and can be overwritten by
            column specific parsing options.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex flex-wrap gap-6">
            <Column $width="220px">
              <ColumnElement>
                <div className="flex items-center gap-2">
                  <Label>Data source</Label>
                  <InfoTooltip
                    description="The data that will be edited by the table editor."
                    title="Data source"
                  />
                </div>
                <VariableSelector
                  onSelected={ref =>
                    (action.metadata.settings.dataPathRef = ref)
                  }
                  placeholder="Select a Table"
                  selectedRef={action.metadata.settings.dataPathRef}
                  specificResolvedTypes={'Table' as ResolvedVariableType}
                />
              </ColumnElement>
            </Column>
          </div>
        </CardContent>
      </Card>
      <Separator />
      <TableSettings
        allowColumnsSelection={action.metadata.settings.allowColumnsSelection}
        dataSelectorPathReference={
          action.metadata.settings.dataSelectorPathReference
        }
        onAllowColumnsSelection={value =>
          (action.metadata.settings.allowColumnsSelection = value)
        }
        onDataSelectorPathReferenceSelected={ref =>
          (action.metadata.settings.dataSelectorPathReference = ref)
        }
        onShowEmptyTableChange={v =>
          (action.metadata.settings.showEmptyTable = v)
        }
        showEmptyTable={action.metadata.settings.showEmptyTable}
        sourceId={action.id}
      >
        <Column $width="220px">
          <ColumnElement>
            <SwitchV2
              checked={action.metadata.settings.addComments}
              id={`enable-comments-${action.id}`}
              labelText="Enable comment"
              onCheckedChange={checked =>
                (action.metadata.settings.addComments = checked)
              }
            />
          </ColumnElement>
        </Column>
      </TableSettings>
    </SettingsSharedTab>
  );
});
